import { Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const ThankYouAndOccasionsWrapper = styled.div`
  background: var(--color-bg-weaker);
  border-left: 1px solid var(--color-border-default);
  height: 100%;
  max-height: 100vh;
  min-width: 320px;
  overflow-y: auto;
  padding: var(--size-24);
  padding-bottom: var(--size-48);
  width: 20%;
`;

const SectionHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--size-16);
`;

const GratitudeCard = styled.div`
  border-radius: var(--size-border-radius-md);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: var(--size-8);
  margin-bottom: var(--size-8);
  padding: var(--size-8);

  :hover {
    background-color: var(--color-bg-weakest);
  }
`;

const GratitudeCardHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const GratitudeCardUser = styled.div`
  align-items: center;
  display: flex;
  gap: var(--size-8);
`;

const OccasionsWrapper = styled.div`
  padding-bottom: var(--size-24);
`;

const MonthSection = styled.div`
  margin-bottom: var(--size-24);

  &:last-child {
    margin-bottom: 0;
  }
`;

const MonthTitle = styled(Typography)`
  margin-bottom: var(--size-16);
`;

const OccasionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--size-8);
`;

const OccasionItem = styled.div`
  align-items: center;
  background-color: var(--color-bg-default);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--size-border-radius-md);
  cursor: pointer;
  display: flex;
  padding: var(--size-8) var(--size-12);
`;

const DateBox = styled.div`
  margin-right: var(--size-16);
  text-align: center;
  width: 40px;
`;

const OccasionInfo = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  gap: var(--size-8);
`;

export {
  DateBox,
  GratitudeCard,
  GratitudeCardHeader,
  GratitudeCardUser,
  MonthSection,
  MonthTitle,
  OccasionInfo,
  OccasionItem,
  OccasionList,
  OccasionsWrapper,
  SectionHeader,
  ThankYouAndOccasionsWrapper
};
